module.exports = __webpack_public_path__ + "images/花筑奢pr长图_04-4.jpg?v=d9b5c324";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_04-4.jpg
 ** module id = 33
 ** module chunks = 1 2
 **/